export class AccessRequestDTO {

    loginUsuario: string;
	passwordUsuario: string;
	tipoAcceso: string;

}